import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { indexedDbKeys } from './modules/polly-manage/@core/datasets/manage-indexed-db-keys.dataset';
import { RouterModule } from '@angular/router';
import { PollyCommonsModule, ENVIRONMENT_TOKEN, APP_NAME_TOKEN, SENTRY_URL_TOKEN } from 'polly-commons';
import { PollySpinnerModule } from 'polly-qubit';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MessageService } from 'primeng/api';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule, CommonModule, BrowserAnimationsModule, RouterModule, AppRoutingModule, PollySpinnerModule, PollyCommonsModule.forRoot()],
  providers: [
    MessageService,
    { provide: APP_NAME_TOKEN, useValue: 'manage' },
    { provide: ENVIRONMENT_TOKEN, useValue: environment },
    { provide: SENTRY_URL_TOKEN, useValue: indexedDbKeys.sentryUrl },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
